import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Popover.css';

const Popover = ({ top, left, right, style={}, position='LEFT', translateX=false, translateY=false, children }) => (
  <div
    name="Popover"
    className={classNames({ 'translate-x': translateX, 'translate-y': translateY })}
    style={{ ...style, top, left, right }}
    data-pos={position}>
    {children}
  </div>
);

const numberOrString = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.string
]);

Popover.propTypes = {
  top: numberOrString,
  left: numberOrString,
  right: numberOrString,
  style: PropTypes.object,
  position: PropTypes.string,
  translateX: PropTypes.bool,
  translateY: PropTypes.bool,
  children: PropTypes.any
};

export default Popover;
